import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FilterButtonComponent } from './components/filter-button/filter-button.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterSidebarComponent } from './components/filter-sidebar/filter-sidebar.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
  ],
  declarations: [FilterButtonComponent, FilterSidebarComponent],
  exports: [FilterButtonComponent, FilterSidebarComponent],
})
export class FilterUtilityModule {}
